import React from "react";
import { withTranslation } from "react-i18next";
import { Row, Col, Button } from "components/bootstrap";
import { Icon } from "components/common";
import * as ISODurationUtils from "util/ISODurationUtils";
import ObjectUtils from "util/ObjectUtils";
class TimeRangeOptionsForm extends React.Component {
  constructor() {
    super(...arguments);
    this._update = (options) => {
      this.props.update(options);
    };
    this._onAdd = () => {
      const options = ObjectUtils.clone(this.props.options);
      if (options) {
        options.push({ period: "", description: "" });
        this._update(options);
      }
    };
    this._onRemove = (removedIdx) => () => {
      const options = ObjectUtils.clone(this.props.options);
      options.splice(removedIdx, 1);
      this._update(options);
    };
    this._onChange = (changedIdx, field) => (e) => {
      const options = ObjectUtils.clone(this.props.options);
      options.forEach((_o, idx) => {
        if (idx === changedIdx) {
          let { value } = e.target;
          if (field === "period") {
            value = value.toUpperCase();
            if (!value.startsWith("P")) {
              value = `P${value}`;
            }
          }
          options[idx][field] = value;
        }
      });
      this._update(options);
    };
    this._buildTimeRangeOptions = () => this.props.options.map((option, idx) => {
      const { period } = option;
      const { description } = option;
      const errorStyle = ISODurationUtils.durationStyle(period, this.props.validator, "error");
      return /* @__PURE__ */ React.createElement("div", { key: `timerange-option-${idx}` }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { xs: 4 }, /* @__PURE__ */ React.createElement("div", { className: `input-group ${errorStyle === "error" ? "has-error" : null}` }, /* @__PURE__ */ React.createElement("input", { type: "text", className: "form-control", value: period, onChange: this._onChange(idx, "period") }), /* @__PURE__ */ React.createElement("span", { className: "input-group-addon" }, ISODurationUtils.formatDuration(period, this.props.validator)))), /* @__PURE__ */ React.createElement(Col, { xs: 8 }, /* @__PURE__ */ React.createElement("div", { className: "input-group" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          className: "form-control",
          placeholder: this.props.t("time_range_options.add_description"),
          value: description,
          onChange: this._onChange(idx, "description")
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "input-group-addon" }, /* @__PURE__ */ React.createElement(Icon, { name: "delete", style: { cursor: "pointer" }, onClick: this._onRemove(idx) }))))));
    });
  }
  render() {
    var _a;
    return /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement("label", { className: "control-label" }, this.props.title), /* @__PURE__ */ React.createElement("span", { className: "help-block" }, this.props.help), /* @__PURE__ */ React.createElement("div", { className: "wrapper" }, this._buildTimeRangeOptions()), /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", onClick: this._onAdd }, (_a = this.props.addButtonTitle) != null ? _a : this.props.t("time_range_options.add_option")));
  }
}
TimeRangeOptionsForm.defaultProps = {
  options: [],
  addButtonTitle: void 0,
  validator: () => true
};
export default withTranslation("configurations")(TimeRangeOptionsForm);
